// Debug logger that only logs in development
const isDevelopment = process.env.NODE_ENV === 'development';

export const debugLog = {
  auth: (message: string, ...args: any[]) => {
    if (isDevelopment) console.log(`[Auth] ${message}`, ...args);
  },
  businessProfile: (message: string, ...args: any[]) => {
    if (isDevelopment) console.log(`[BusinessProfile] ${message}`, ...args);
  },
  dashboard: (message: string, ...args: any[]) => {
    if (isDevelopment) console.log(`[Dashboard] ${message}`, ...args);
  },
  retry: (message: string, ...args: any[]) => {
    if (isDevelopment) console.log(`[Retry] ${message}`, ...args);
  },
  warn: (message: string, ...args: any[]) => {
    if (isDevelopment) console.warn(message, ...args);
  },
};

